import { Button } from "@/components/ui/Button";

/**
 * ManufacturingSection Component
 * Manufacturing and quality information
 */
export function ManufacturingSection() {
  const acfData = window.post_template || [];
  const ctaLink = window.cta_link || "#";

  return (
    <section
      className="py-20 px-8 bg-white relative overflow-hidden
                        max-md:py-12 max-md:px-4"
    >
      {/* Decorative rounded corners */}
      <div className="absolute top-0 left-0 right-0 h-[22px] bg-[#F4F2EF] rounded-b-[22px] z-0" />
      <div className="absolute bottom-0 left-0 right-0 h-[22px] bg-background rounded-t-[22px] z-0" />

      <div
        className="grid grid-cols-2 gap-12 items-center max-w-[1200px] mx-auto relative z-[1]
                      max-md:grid-cols-1 max-md:gap-4"
      >
        {/* Image */}
        <div className="overflow-hidden">
          <img
            src={`${window.template_root}/src/public/img/manufacturing.webp`}
            alt="Manufacturing facility"
            className="w-full h-auto object-contain rounded-[1.5rem] block"
            loading="lazy"
          />
        </div>

        {/* Text Content */}
        <div className="flex flex-col gap-4">
          <h2
            className="font-family-title text-[2.5rem] font-normal text-left mb-0.5 leading-tight
                         max-md:text-[1.8rem] max-md:leading-[1.25] max-md:mb-0 max-md:text-left"
          >
            Our Manufacturing
          </h2>
          <p className="text-gray leading-relaxed max-md:text-[0.95rem] max-md:leading-relaxed">
            We manufacture the product ourselves to ensure the highest quality
            production and supply-chain, cutting out the middleman along the
            way.
          </p>
          <p className="text-gray leading-relaxed max-md:text-[0.95rem] max-md:leading-relaxed">
            We keep costs low in order to design better products that fit your
            lifestyle and needs.
          </p>
          <p className="text-gray leading-relaxed max-md:text-[0.95rem] max-md:leading-relaxed">
            The goal? To deliver better value and superior products to our
            customers.
          </p>
          <Button
            href={ctaLink}
            variant="secondary"
            className="mt-6 self-start max-md:mt-2 max-sm:w-full"
          >
            {acfData.tr_cta_text}
          </Button>
        </div>
      </div>
    </section>
  );
}

export default ManufacturingSection;
